
import axios from '../axios-instance';

export const updateContentStatus = async (content, status, device, user = null) => {

        console.log('Updating content status...');

        let uri;

        let headers = {
            'Content-Type': 'application/json',
            'x-device-uuid': `${device.uuid}`,
        }

        if(user) {
            headers['Authorization'] = 'Bearer ' + user.token;
            uri = `/user/${user.id}/content/${content.id}?status=${status}`;
        } else {
            uri = `/device/${device.uuid}/content/${content.id}?status=${status}`;
        }

        await axios.put(uri,
            {
            // payload
            },{
                headers: headers,
            }
        ).then((res) => {
            if (res.status === 200) {
                if (res.data.message) {
                    console.log('STATUS: ', status + ' ', res.data.message);
                }
            }
        }
        ).catch((err) => {
            console.error('Error: ', err);
        });

}

/**
 * postEvent: 
 *      device
 *      event 
 *          category: string
 *          subcategory: string
 *          action: string
 *          label: string
 *          client_id : int | null
 *          campaign_id int | null
 *          content_id : int | null
 *          trigger_id : int | null
 **/   

export const postEvent = async(device, event, user = null, redirect = null) => {    
    
    let headers = {
        'Content-Type': 'application/json',
        'x-device-uuid': `${device.uuid}`,
    }

    if(user) {
        headers['Authorization'] = 'Bearer ' + user.token
    }

    await axios.post(`/event`, event, {
        headers: headers
        }).then((res) => {
            if (res && res.data) {
                console.log('Event tracked', res.data);
                if(redirect) {
                    window.open(redirect.url, redirect.target?? '_blank');
                }
            }
        }).catch((err) => {
            console.error('Error: ', err);
        }
    );
}

export const getCdnPath = (url) =>{
    
    if(!url) {
        return;
    } else if(!process.env.REACT_APP_CDN_ENABLED || process.env.REACT_APP_CDN_ENABLED !== 'true' || !process.env.REACT_APP_CDN_ORIGIN || !process.env.REACT_APP_CDN_HOST){
        return url;
    }

    return url.replace(
        process.env.REACT_APP_CDN_ORIGIN,
        process.env.REACT_APP_CDN_HOST
    );
}

export const createMarkup = (richText) => {
    return {__html: richText};
}